import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/ScrollReveal';
import WhatsAppButton from '@/components/WhatsAppButton';
import { CalendarCheck, ClipboardCheck, Mail } from 'lucide-react';

const STEPS = [
  { icon: CalendarCheck, title: 'Schedule Inspection', desc: 'Book via our online form or call 0208 935 5492 to arrange a convenient slot.' },
  { icon: ClipboardCheck, title: 'On-Site Inspection', desc: 'Our clerk attends the property and carries out a detailed inspection.' },
  { icon: Mail, title: 'Receive Your Report', desc: 'We process the data within 24–48 hours and email you the report.' },
];

export default function CampaignHowItWorks() {
  return (
    <section className="py-16 md:py-32 bg-navy text-white">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="text-center mb-16">
            <p className="caps-label text-orange mb-4">How We Work</p>
            <h2 className="font-display font-extrabold" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Three simple steps
            </h2>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {STEPS.map((s, i) => (
            <ScrollReveal key={s.title} delay={i * 0.15}>
              <div className="relative">
                <div className="flex items-center gap-4 mb-6">
                  <div className="flex-shrink-0 w-14 h-14 rounded-full bg-orange text-navy flex items-center justify-center font-extrabold text-xl">
                    {i + 1}
                  </div>
                  <s.icon className="text-orange" size={32} />
                </div>
                <h3 className="text-lg font-semibold mb-3">{s.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{s.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
        <ScrollReveal delay={0.4}>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-16">
            <Link to="/request-quote" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-orange text-navy font-semibold rounded-full hover:bg-orange-dark transition-colors">
              Book Your Inspection
            </Link>
            <WhatsAppButton label="Chat on WhatsApp" />
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}